import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Image from '@components/Image';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { SyntheticEvent, useRef, useState } from 'react';
import { PostContactRequest, post_contact } from '@services/contact';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { useTheme } from '@mui/material/styles';
import { resize_image } from '@utils/image';

const defaultValues: PostContactRequest = {
  email: '',
  message: '',
  name: '',
  subject: '',
};

const forCorporateImage = resize_image({
  url: 'https://images.potioneer.com/images-for-corporate/map_XG9tf2slu.webp',
  width: 576,
  height: 645,
});

const ForCorporateContactUs = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [formValues, setFormValues] = useState<PostContactRequest>(defaultValues);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    console.log(formValues);

    post_contact(formValues).then((res) => {
      setIsSubmitted(true);
      if (res?.code !== '200') {
        setIsSuccess(false);
        return;
      }
      setIsSuccess(true);
      setFormValues(defaultValues);
    });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  return (
    <Grid
      container
      paddingY={{
        xs: 4,
        md: 10,
      }}
    >
      <Grid
        item
        xs={12}
        md={6}
        pr={{
          xs: 0,
          md: 10,
        }}
      >
        <Typography variant="h3">Feel free to contact us.</Typography>
        <Typography variant="h3">We&apos;ll be glad to hear from you.</Typography>
        <form onSubmit={handleSubmit}>
          <Stack spacing={2} mt={6} mb={1.7}>
            <TextField
              label="Name"
              type="text"
              required
              name="name"
              value={formValues.name}
              onChange={handleInputChange}
            />
            <TextField
              label="Email"
              type="text"
              required
              name="email"
              value={formValues.email}
              onChange={handleInputChange}
            />
            <TextField
              label="Subject"
              type="text"
              required
              name="subject"
              value={formValues.subject}
              onChange={handleInputChange}
            />
            <TextField
              multiline
              rows={4}
              label="Enter your message here"
              required
              name="message"
              value={formValues.message}
              onChange={handleInputChange}
            />
          </Stack>
          <Button
            type="submit"
            variant="contained"
            sx={{ paddingX: '22px', paddingY: '11px', color: theme.palette.grey[4] }}
          >
            <Typography fontWeight="bold" fontSize="15px">
              Submit Now
            </Typography>
          </Button>
        </form>
      </Grid>
      <Grid item xs={12} md={6} mt={isTablet ? 3 : 0}>
        <img
          src={forCorporateImage}
          alt="corporate-dinner.svg"
          style={{ marginTop: isTablet ? 0 : 6, borderRadius: 16 }}
        />
      </Grid>

      <Snackbar
        open={isSubmitted}
        autoHideDuration={6000}
        onClose={() => setIsSubmitted(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {isSuccess ? (
          <Alert severity="success">
            We’ve received your message and will get back to you within 2-3 working days
          </Alert>
        ) : (
          <Alert severity="error" onClose={() => setIsSubmitted(false)}>
            Something went wrong
          </Alert>
        )}
      </Snackbar>
    </Grid>
  );
};

export default ForCorporateContactUs;
